import React from "react";
import LegalPage from "./LegalPage";

export default function TermsAndConditions() {
  return <LegalPage slug="terms-and-conditions" fallbackTitle="Terms & Conditions" />;
}
